var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "23px",
    height: "34px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(156, 154, 155)",
    d: "M11.499,11.131 C5.159,11.131 0.000,16.261 0.000,22.569 C0.000,28.875 5.159,34.006 11.499,34.006 C17.840,34.006 22.1000,28.875 22.1000,22.569 C22.1000,16.261 17.840,11.131 11.499,11.131 ZM11.499,26.283 C9.440,26.283 7.765,24.617 7.765,22.569 C7.765,20.520 9.440,18.854 11.499,18.854 C13.559,18.854 15.234,20.520 15.234,22.569 C15.234,24.617 13.559,26.283 11.499,26.283 ZM7.180,8.923 C7.180,6.554 9.118,4.627 11.500,4.627 C13.882,4.627 15.819,6.554 15.819,8.923 L15.819,10.081 C17.565,10.677 19.147,11.621 20.479,12.834 L20.479,8.923 C20.479,3.1000 16.451,-0.007 11.500,-0.007 C6.549,-0.007 2.521,3.1000 2.521,8.923 L2.521,12.834 C3.852,11.621 5.435,10.677 7.180,10.081 L7.180,8.923 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.2832f759be3758181a44a68bc9900ea1.svg";
export { ForwardRef as ReactComponent };